import { ApiError, isRecord } from '@/api/client';
import type { Blocker } from './environmentLabels';

// The pure helpers live in environmentLabels.ts (unit-testable without the auth client); this module keeps its
// public surface and adds `blockersOf`, which needs `ApiError`.
export { ENV_KINDS, ENV_KIND_LABEL, FORKS_LABEL, archivedEnvironments, blockerLabel, blockerSample, liveEnvironments, type Blocker } from './environmentLabels';

/** The blockers of a 409 from `PATCH /environments/{id}`, or none. */
export function blockersOf(err: unknown): Blocker[] {
  if (!(err instanceof ApiError) || err.status !== 409 || !isRecord(err.details) || !Array.isArray(err.details.blockers)) return [];
  return err.details.blockers.filter((b): b is Blocker => isRecord(b) && typeof b.kind === 'string' && typeof b.count === 'number').map((b) => ({ ...b, items: Array.isArray(b.items) ? b.items.filter(isRecord) : [] }));
}
